import { Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";

export default function InfoManifesto(props: any) {
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto );
    return (
        <div className="px-2 pb-2">
            <Row>
                <Col md>
                    <Form.Group className="mb-3" controlId="infadfisco">
                        <Form.Label>Informações adicionais do interesse do fisco</Form.Label>
                        <Form.Control name="infadfisco"  as="textarea" rows={6} maxLength={2000} 
                            
                            value={formManifesto.infadfisco} onChange={props.handleChange}/>
                    </Form.Group>
                </Col>
            </Row>   
            <Row>
                <Col md>
                    <Form.Group controlId="infcpl">
                        <Form.Label>Informações complementares do interesse do contribuinte</Form.Label>
                        <Form.Control name="infcpl"  as="textarea" rows={6} maxLength={5000} 
                            
                            value={formManifesto.infcpl} onChange={props.handleChange}/>
                    </Form.Group>
                </Col>
            </Row>   
        </div>
    )
}